import { Component, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';

import { environment } from 'src/environments/environment';

@Component({
    selector: 'pk-web-navbar-nav, [pk-web-navbar-nav]',
    templateUrl: './navbar-nav.component.html',
    styleUrl: './navbar-nav.component.scss',
    standalone: false
})
export class NavbarNavComponent {

	@Input() customClass: string;
	@Output() navigated: EventEmitter<boolean> = new EventEmitter();
	@ViewChildren(NgbDropdown) dropdowns: QueryList<NgbDropdown>;

	constructor(private router: Router) {}

	get dashboardLogin() {
		return environment.dashboardLogin;
	}

	get scheduleDemoHref(): string {
		const path = this.router.url.split(/[?#]/)[0];
		if (path === '/landing/solar' || path === '/landing/efficiency') {
			return '/se-form';
		}
		return '/hi-form';
	}

	public closeCanvas(): void {
		// Close all open dropdowns
		this.dropdowns?.forEach(dropdown => {
			if (dropdown.isOpen()) {
				dropdown.close();
			}
		});
		this.navigated.emit(true);
	}
}
